const MaintenancePage = () => (
  <div className="flex items-center justify-center h-screen bg-gray-900 text-white text-center p-4">
    <div>
      <h1 className="text-4xl font-bold mb-4">Site Under Maintenance</h1>
      <p>We’re currently performing updates. Please check back later.</p>
    </div>
  </div>
);

export default MaintenancePage;
